import { vATTreatmentTypeName } from 'api/models/Common/JyrneyEnums'
import { postcodeRegex } from 'app/utils/regex'
import * as yup from 'yup'

const day = (label: string) =>
  yup
    .object()
    .shape({
      when: yup.string().required(),
      fromHour: yup.number().nullable(),
      fromMinute: yup.number().nullable(),
      toHour: yup.number().nullable(),
      toMinute: yup.number().nullable(),
    })
    .label(label)

export default yup.object().shape({
  adminFeePolicy: yup.object().shape({
    chargeTypeName: yup
      .string()
      .required()
      .oneOf(['None', 'Fixed', 'Percentage'])
      .label('Admin fee charge type'),
    price: yup
      .number()
      .when('chargeTypeName', {
        is: 'Fixed',
        then: (schema: any) => schema.required(),
        otherwise: (schema: any) => schema.nullable(),
      })
      .label('Price'),
    percentage: yup
      .number()
      .when('chargeTypeName', {
        is: 'Percentage',
        then: (schema: any) => schema.required(),
        otherwise: (schema: any) => schema.nullable(),
      })
      .label('Percentage'),
  }),
  cancellationPolicy: yup.string().label('Cancellation policy'),
  openingHours: yup
    .object()
    .shape({
      monday: day('Monday'),
      tuesday: day('Tuesday'),
      wednesday: day('Wednesday'),
      thursday: day('Thursday'),
      friday: day('Friday'),
      saturday: day('Saturday'),
      sunday: day('Sunday'),
    })
    .required(),
  operationsContact: yup
    .string()
    .matches(/^\+?[1-9]\d{1,14}$/, 'Contact number must be valid')
    .required()
    .label('Contact number'),
  operationsAddress: yup
    .object()
    .when('isSameAddress', {
      is: true,
      then: (schema: any) => schema.nullable(),
      otherwise: yup
        .object()
        .shape({
          addressLine1: yup.string().required().label('Address line 1'),
          addressLine2: yup.string().nullable().label('Address line 2'),
          town: yup.string().required().label('town'),
          county: yup.string().nullable().label('county'),
          postCode: yup
            .string()
            .required()
            .when('country', {
              is: (country: string) =>
                ['uk', 'gb', 'united kingdom', 'great britain'].includes(
                  (country || '').trim().toLowerCase(),
                ),
              then: (schema: any) =>
                schema.matches(postcodeRegex, 'You must enter a valid Postcode'),
            })
            .label('Postcode'),
          country: yup.string().required().label('Country'),
        })
        .label('Operations Address'),
    })
    .label('Operations Address'),
  operationsEmail: yup.string().required().label('Email'),
  serviceChargeTypeName: yup
    .string()
    .required()
    .oneOf(['Fixed', 'Percentage'])
    .label('Service charge type'),
  serviceChargeValue: yup
    .number()
    .when('serviceChargeTypeName', {
      is: true,
      then: (schema: any) => schema.required(),
      otherwise: (schema: any) => schema.nullable(),
    })
    .label('Service charge value'),
  vATTreatmentTypeName: yup
    .string()
    .required()
    .oneOf(Object.keys(vATTreatmentTypeName))
    .label('VAT Treatment'),
  applyPrivateDriverPolicy: yup.boolean().label('Private Driver Policy'),
  minimumTimeRequiredForBooking: yup
    .number()
    .required()
    .label('Minimum Time Required For Booking'),
})
